import React from 'react';
import Address from './Address';
import './Cart.css';


const PaymentSummary = ({cart,total,itemTotal,plusMembership}) => {
  
  
  // console.log(cart)
  return (
    <div className='paymentpage'>
      {/* <pre>{JSON.stringify(cart)}</pre> */}
        <div className='heading2'>Payment summary</div>
        <div className='div1'>Item total<div>₹{itemTotal}</div></div>
        <div className='div1'>Item discount<div className='div2'>-₹{cart.Itemdiscount}</div></div>
        <div className='div1'>Membership Discount<div className='div2'>-₹{cart.MembershipDiscount}</div></div>
        <div className='div1'>Taxes and Fee<div>₹{cart.TaxesandFee}</div></div>
        <div className='div1'>Plus Membership<div>₹{plusMembership}</div></div>
       
        <hr className='total' />
        <div className='totalprice'>Total<div>₹{total}</div></div>
        <div className='savemoney'>Yay! You have saved ₹80 on final bill</div>
        <hr className='total' />
        <div className='div1'>Coupons and offers<div className='div3'>5 offers</div></div>
        <hr className='total' />
        <div className='div4'>Add a trip to thank the Professional</div>

        <div className='div5'>
          <div>₹30</div>
          <div>₹50 <span className='popular'>POPULAR</span></div>
          <div>₹100</div>
          <div>Custom</div>
        </div>
        <div className='div6'>100% of the tip goes to the professional</div>
        <div></div>
        
        <Address amount={total} />
        

      
    </div>
  )
}

export default PaymentSummary
